<template id='content'>
	<div class="bg">
		<div class="top">
			<div class="top_c">
				<div>找回密码</div>
			</div>
		</div>
		<div class="bottom">
			<div class="b_t">找回密码</div>
			<div class="b_c">
				<div class="clearfix">
					<div class="b_c_1" v-for="(stepitem,idx) in steplist" :key="idx">
						<div class="b_c_1_bg" :class="{background:idx==step,background1:idx<step}"></div>
						<div class="b_c_1_c" :class="{background:idx==step,background1:idx<step}">{{stepitem.id+1}}</div>
						<div class="b_c_1_t" :class="{color:idx==0,color1:idx<step}">{{stepitem.text}}</div>
					</div>
				</div>
			</div>
			<div>
				<ul class="ul1">
					<li class="clearfix">
						<span class="fl">手机号：</span>
						<input type="text" maxlength="11" v-model="phone" placeholder="手机号">
					</li>
					<li class="clearfix">
						<span class="fl">验证码：</span>
						<input type="text" v-model="txtcode" placeholder="验证码">
						<i class="fl">
							<img :src="verifyCode" alt="">
						</i>
						<b style="line-height: 36px;margin-left: 10px;" class="fl" @click="gettxtcode">看不清？换一张</b>
					</li>
					<li class="clearfix" style="margin-left:51px;">
						<input @click="step1" type="button" class="one_ulbtn" value="提交">
						<input @click="register" type="button" class="one_ulbtn" value="注册">
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import Qs from 'qs'
	import { ip,sha1 } from '../../assets/js/public.js'
  import bus from '../../assets/js/eventBus'

	export default {
		data () {
			return {
				steplist:[{'id':0,'text':'填写账户名'},{'id':1,'text':'验证身份'},{'id':2,'text':'设置新密码'},{'id':3,'text':'完成'}],
				phone:'',
				txtcode:'',
				verifyCode:'',
				step:null
			}
		},
		mounted:function () {
			var t_=this
			var data0bj = Qs.stringify({})
			t_.step=t_.$route.query.step-1
			axios.post(
				`${ip}formWorkInterface/verifyCode`,data0bj
			).then( res => {
				if(res.data.code==300){
					var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
					return window.open(href.href,'_blank')
				}
				if(res.data.code==0)t_.verifyCode='data:image/png;base64,'+res.data.pic
			} )
		},
		methods:{
			register:function(){
				var t_=this
				var href=this.$router.resolve({name:'LoginHome',query:{b:2}})
				window.open(href.href,'_blank')
			},
			gettxtcode:function(){
				var t_=this
				var timestamp=Date.parse(new Date())
				var data0bj=Qs.stringify({
					t:timestamp
				})
				var xhrFields = {
					withCredentials: true
				}
				axios.post(
					`${ip}formWorkInterface/verifyCode`,data0bj,xhrFields
				).then( res => {
					if(res.data.code==300){
						var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
						return window.open(href.href,'_blank')
					}
					if(res.data.code==0)t_.verifyCode='data:image/png;base64,'+res.data.pic
				} )
			},
			step1:function(){
				var t_=this
				var re2 = /\d{11}$/
				if(t_.phone=='')return this.$message({
					message:'请填写手机号',
					center:true,
					type:'warning'
				})
				if(!re2.test(t_.phone))return this.$message({
					message:'手机号码输入有误',
					center:true,
					type:'warning'
				})
				if(!t_.txtcode)return this.$message({
                  message:'请输入验证码',
                  center:true,
                  type:'warning'
                })
				//if(t_.txtcode!=t_.verifyCode)return('验证码错误，请重新填写')
				var data0bj = Qs.stringify({
					mobilePhone:t_.phone,
					authCode:t_.txtcode,
        	channel:2,
				})
				var xhrFields = {
					withCredentials: true
				}
				axios.post(
					`${ip}formWorkInterface/memberByphone`,data0bj,xhrFields
				).then( res => {
					if(res.data.code==300){
						var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
						return window.open(href.href,'_blank')
					}
					if(res.data.code!=1)return this.$message({
						message:res.data.message,
						center:true,
						type:'warning'
					})
					localStorage.setItem('member0bj',JSON.stringify(res.data.data));
					this.$router.push({path: '/setPassword2',query:{ step:2}});
				} )
			}
		}
	}
</script>

<style>
	/* input{
		float: none;
	} */
	html,body{
    height: 100%;
  }
	.clearfix {
		overflow: auto;
		_height: 1%;
	}
	.fl{
		float: left;
	}
	.bg{
		background: #f5f5f5;
		height: 100%;
	}
	.top{
		background: #fff;
		height: 116px;
		border-bottom: 3px solid #ff2c4c;
	}
	.top_c{
		width: 990px;
		height: 116px;
		margin: 0 auto;
	}
	.top_c div{
		font-size: 24px;
		color:#2d2d2d;
		margin-left: 20px;
		line-height: 96px;
	}
	.bottom{
		width: 990px;
		height: 530px;
		background: #fff;
		margin: 0 auto;
	}
	.b_t{
		height: 44px;
		padding: 24px 0 0 21px;
		color:#666;
		font-weight: 900;
	}
	.b_c{
		width: 634px;
		margin: 0 auto;
		overflow: hidden;
	}
	.b_c_1{
		width: 25%;
		height: 40px;
		position: relative;
		float: left;
		overflow: hidden;
	}
	.b_c_1_bg{
		width: 100%;
		height: 5px;
		background: #cdcdcd;
		position: absolute;
		top: 10px;
	}
	.b_c_1_c{
		width: 23px;
		height: 23px;
		border-radius: 50%;
		background: #cdcdcd;
		color: #fff;
		text-align: center;
		line-height: 23px;
		margin: 0 auto;
		position: relative;
	}
	.b_c_1_t{
		color:#666;
		text-align: center;
		margin-top: 1px;
	}
	.background{
		background: #7abd54;
	}
	.color{
		color:#7abd54;
	}
	.color1{
		color:#7abd54;
	}
	.background1{
		background:#cbedb7;
	}
	.bottom .ul1{
		margin-top: 44px;
		margin-left: 357px;
	}
	.bottom .ul1 li{
		margin-bottom: 21px;
	}
	.bottom .ul1 li span{
		line-height: 36px;
	}
	.bottom .ul1 input{
		width: 150px;
		height: 34px;
		border: 1px solid #cdcdcd;
		padding-left: 5px;
	}
	.bottom .ul1 i{
		display: inline-block;
		width: 80px;
		height: 30px;
		/* border: 1px solid #cdcdcd;
		border-radius: 10px; */
		margin-left: 21px;
		text-align: center;
		line-height: 36px;
		color:#dd2c3a;
		font-style: normal;
	}
	.bottom .ul1 b{
		font-weight: 100;
		cursor: pointer;
	}
	.bottom .ul1 .one_ulbtn{
		width: 62px;
		height: 32px;
		border: 0;
		border-radius: 10px;
		background:#dd2c3a;
		text-align: center;
		line-height: 32px;
		color: #fff;	
		padding: 0;
		margin-right: 20px;
	}
	/* .ul2{
		margin-top: 44px;
		margin-left: 315px;
	}
	.ul2 .t{
		width: 140px;
		text-align: right;
		line-height: 30px;
	}
	.ul2 li{
		margin-bottom: 20px;
	}
	.ul2 select{
		width: 185px;
		height: 30px;
	}
	.ul2 .t1{
		line-height: 30px;
		font-weight: 900;
	}
	.ul2 .code{
		width: 150px;
		height: 34px;
		background:#ebebe5;
		border: 1px solid #cdcdcd;
		padding-left: 5px;
	}
	.ul2 .getcode{
		width: 128px;
		height: 36px;
		border-radius: 10px;
		border: 1px solid #bfbebf;
		color: #de2c3a;
		background: #fff;
		margin-left: 20px;
	}
	.ul2 .btn{
		width: 62px;
		height: 32px;
		border: 0;
		border-radius: 7px;
		color:#fff;
		background: #de2c3a;
		margin-left: 139px;
	} */
</style>


// WEBPACK FOOTER //
// src/components/setPassword/setPWD1.vue